import { useState } from "react";
import MediaDetailPlayer from "@/components/MediaDetail/MediaDetailPlayer";

const mockMedia: any = {
  id: "test123",
  state: 7,
  media_ref: {},
  images: {},
  mtbydata: {},
};

const PreviewTest = () => {
  const [state, setState] = useState(7);
  const media = { ...mockMedia, state };
  return (
    <div style={{ padding: 40 }}>
      <div style={{ marginBottom: 16 }}>
        {[1, 2, 3, 7, 8, 9, 10].map((s) => (
          <button key={s} onClick={() => setState(s)} style={{ marginRight: 8 }}>
            state={s}
          </button>
        ))}
      </div>
      <div style={{ width: 480, height: 270, border: "1px solid red" }}>
        <MediaDetailPlayer
          currentMediaDetailsForEdit={media}
          isWizard={false}
          isPlayerInitialized={false}
          setIsPlayerInitialized={() => {}}
          thumbSent=""
          formik={{ values: {}, handleBlur: () => {}, errors: {}, touched: {}, setFieldValue: () => {} } as any}
          statusOptions={[]}
          setIsSaveAndPublishClicked={() => {}}
        />
      </div>
    </div>
  );
};

export default PreviewTest;
